module.exports = __webpack_public_path__ + "static/media/emo2.c58ccc00.svg";